// extracted by mini-css-extract-plugin
module.exports = {"badge":"DeXZpBLD","moreFilterPill":"JR2CN7qC"};